import React, { useState } from "react";

import WithMainLayout from "../../hocs/layouts/MainLayout";
import { CommonTable } from "./CommonTable";
import { useDocTitle, useForm } from "../../utils/hooks";
import {
  getBeneficios,
  getMediosEnvio,
  getMotivosReclamos,
  getReclamoById,
  getReclamos,
  getSolicitudById,
  getSolicitudes,
  getTiposSolicitud,
  saveReclamo,
  saveSolicitud,
} from "../../services/requestsClaims";
import Constants from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import Modal from "../common/Modal";
import Select from "../common/Select";
import FileUploader from "../common/FileUploader";
import { useGlobalStore } from "../../utils/global";
import { fileToBase64, fileToByteArray } from "../../utils/utilities";

const OPTIONS = Object.freeze({
  BENEFICIOS: "BENEFICIOS",
  SOLICITUDES: "SOLICITUDES",
  RECLAMOS: "RECLAMOS",
});

const defaultSolicitud = {
  asunto: "Asunto",
  comentario: "" /*Comentario*/,
  fuente: "1",
  oficina: "1",
  motivoID: null /*MotivoSeleccionado*/,
  medioRespuestaID: null /*MedioRespuestaSeleccionado*/,
  fecSolicitud: new Date(),
  documentos: null,
};

const defaultReclamacion = {
  comentario: "" /*Comentario*/,
  fuente: "1",
  oficina: "1",
  motivoID: null /* Motivo Seleccionado*/,
  medioRespuestaID: null /*MedioRespuestaSeleccionado*/,
  fecSolicitud: new Date(),
  documentos: null,
};

function BenefitsRequestsClaims() {
  useDocTitle("Solicitudes & Reclamaciones");
  const navigate = useNavigate();
  const { user, showNotification } = useGlobalStore();
  const [currentSelection, setCurrentSelection] = useState(
    OPTIONS.SOLICITUDES.toString()
  );
  const [isOpenSol, setIsOpenSol] = useState(false);
  const [isOpenRec, setIsOpenRec] = useState(false);

  const [tiposSolicitud, setTiposSolicitud] = useState([]);
  const [tiposReclamacion, setTiposReclamacion] = useState([]);
  const [mediosEnvio, setMediosEnvio] = useState([]);

  const [
    formStateSol,
    setErrorSol,
    changeHandlerSol,
    resetAllSol,
    resetErrorsSol,
    setInitialDataSol,
  ] = useForm({
    ...defaultSolicitud,
  });

  const [
    formStateRec,
    setErrorRec,
    changeHandlerRec,
    resetAllRec,
    resetErrorsRec,
    setInitialDataRec,
  ] = useForm({
    ...defaultReclamacion,
  });

  function closeFormSol() {
    setInitialDataSol(defaultSolicitud);
    setIsOpenSol(false);
  }

  function closeFormRec() {
    setInitialDataRec(defaultReclamacion);
    setIsOpenRec(false);
  }

  function disableButtonSol() {
    return (
      !formStateSol.data.comentario ||
      !formStateSol.data.motivoID ||
      !formStateSol.data.medioRespuestaID
    );
  }

  function submitFormSol() {
    saveSolicitud(formStateSol.data).then((res) => {
      if (res && res.data.successed) {
        showNotification({
          isError: false,
          title: "Solicitud guardada satisfactoriamente",
          duration: 2000,
        });
        closeFormSol();
      } else {
        showNotification({
          isError: false,
          title: res.data.message[0].message,
          duration: 2000,
        });
      }
    });
  }

  function disableButtonRec() {
    return (
      !formStateRec.data.comentario ||
      !formStateRec.data.motivoID ||
      !formStateRec.data.medioRespuestaID
    );
  }

  function submitFormRec() {
    saveReclamo(formStateRec.data).then((res: any) => {
      if (res && res.data.successed) {
        showNotification({
          isError: false,
          title: "Reclamo guardado satisfactoriamente",
          duration: 2000,
        });
        closeFormRec();
      } else {
        if (res != undefined) {
          showNotification({
            isError: false,
            title: res.data.message[0].message,
            duration: 2000,
          });
        }
      }
    });
  }

  return (
    <>
      <div className="block pt-12 pb-[100px]">
        <nav className="flex items-center gap-2 md:gap-4 overflow-auto xl:w-full lg:w-[580px] md:w-[450px] w-full">
          <button
            className={`item-tab${
              currentSelection === OPTIONS.SOLICITUDES ? " active" : ""
            }`}
            onClick={() => setCurrentSelection(OPTIONS.SOLICITUDES)}
          >
            <div className="icon-container">
              <i className="icon icon-service"></i>
            </div>
            <h5>Solicitudes de Servicios</h5>
          </button>

          <button
            className={`item-tab${
              currentSelection === OPTIONS.RECLAMOS ? " active" : ""
            }`}
            onClick={() => setCurrentSelection(OPTIONS.RECLAMOS)}
          >
            <div className="icon-container">
              <i className="icon icon-reclamation"></i>
            </div>
            <h5>Reclamaciones</h5>
          </button>

          <button
            className={`item-tab${
              currentSelection === OPTIONS.BENEFICIOS ? " active" : ""
            }`}
            onClick={() => setCurrentSelection(OPTIONS.BENEFICIOS)}
          >
            <div className="icon-container">
              <i className="icon icon-cashv2"></i>
            </div>
            <h5>Solicitudes de Beneficios</h5>
          </button>
        </nav>

        {/* TABLA BENEFICIOS */}
        {currentSelection === OPTIONS.BENEFICIOS && (
          <CommonTable
            getData={async () => {
              return (await getBeneficios()).data.value;
            }}
            createText="Crear Beneficio"
            icon="cashv2"
            emptyTableTitle="No tienes ningún beneficio disponible"
            emptyTableDesc="Debes crear un beneficio para poder consultar la información rapidamente"
            onCreate={() => {
              navigate(Constants.APPURLS.BENEFITS);
            }}
          />
        )}

        {/* TABLA SOLICITUDES */}
        {currentSelection === OPTIONS.SOLICITUDES && (
          <CommonTable
            getData={async () => {
              const response = await getSolicitudes();
              return response.data.value;
            }}
            createText="Crear Solicitud"
            icon="service"
            emptyTableTitle="No tienes ninguna solicitud disponible"
            emptyTableDesc="Debes crear una solicitud para poder consultar la información rapidamente"
            getDetailById={getSolicitudById}
            onCreate={() => {
              getTiposSolicitud().then((res) => {
                setTiposSolicitud(
                  res.data.value.map((d) => {
                    return { value: d.codigoTipo, label: d.descripcion };
                  })
                );
              });
              getMediosEnvio().then((res) => {
                setMediosEnvio(
                  res.data.value.map((d) => {
                    return { value: d.codigoMedio, label: d.descripcion };
                  })
                );
              });
              setIsOpenSol(true);
            }}
          />
        )}

        {/* TABLA RECLAMOS */}
        {currentSelection === OPTIONS.RECLAMOS && (
          <CommonTable
            getData={async () => {
              const response = await getReclamos();
              return response.data.value;
            }}
            createText="Crear Reclamo"
            icon="reclamation"
            emptyTableTitle="No tienes ningún reclamo disponible"
            emptyTableDesc="Debes crear un reclamo para poder consultar la información rapidamente"
            getDetailById={getReclamoById}
            onCreate={() => {
              if (tiposReclamacion.length === 0) {
                getMotivosReclamos()
                  .then((res) => {
                    const filteredMotivos = res.data.value.filter(
                      (d) => !d.descripcion.toLowerCase().includes("desea desafiliarse")
                    );
                    const formattedMotivos = filteredMotivos.map((d) => ({
                      value: d.codMotivo,
                      label: d.descripcion,
                    }));
                    setTiposReclamacion(formattedMotivos);
                  })
                  .catch((error) => {
                    console.error("Error fetching motivos:", error);
                  });
              }
              
              if (mediosEnvio.length === 0) {
                getMediosEnvio().then((res) => {
                  setMediosEnvio(
                    res.data.value.map((d) => {
                      return { value: d.codigoMedio, label: d.descripcion };
                    })
                  );
                });
              }

              setIsOpenRec(true);
            }}
          />
        )}
      </div>

      {/* MODAL CREAR SOLICITUD */}
      <Modal
        title="Crear solicitud"
        show={isOpenSol}
        onClose={() => setIsOpenSol(false)}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="block space-y-6 lg:space-y-8 w-full"
        >
          <Select
            options={tiposSolicitud}
            selectedOption={formStateSol.data.motivoID}
            handelChange={(value) => {
              changeHandlerSol("motivoID", value)();
            }}
            placeholder="Seleccione tipo de solicitud"
            label="Tipo de solicitud"
          />
          <div className="form-group">
            <label>¿Cuál es el motivo?</label>
            <textarea
              className="form-control large"
              placeholder="Escribe aquí"
              value={formStateSol.data.comentario}
              onChange={changeHandlerSol("comentario")}
            />
          </div>
          <Select
            options={mediosEnvio}
            selectedOption={formStateSol.data.medioRespuestaID}
            handelChange={(value) => {
              changeHandlerSol("medioRespuestaID", value)();
            }}
            placeholder="Selecciona"
            label="¿Dónde deseas recibir la respuesta?"
          />

          <div className="grid grid-cols-2 gap-4 md:gap-6 pt-[128px] md:pt-8">
            <button
              type="button"
              className="btn btn-secondary btn-large w-full"
              onClick={() => closeFormSol()}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary btn-large w-full"
              disabled={disableButtonSol()}
              onClick={submitFormSol}
            >
              Enviar
            </button>
          </div>
        </form>
      </Modal>

      {/* MODAL CREAR RECLAMACIÓN */}
      <Modal
        title="Crear reclamación"
        show={isOpenRec}
        onClose={() => setIsOpenRec(false)}
      >
        <form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="block space-y-6 lg:space-y-8 w-full"
        >
          <Select
            options={tiposReclamacion}
            selectedOption={formStateRec.data.motivoID}
            handelChange={(value) => {
              changeHandlerRec("motivoID", value)();
            }}
            placeholder="Seleccione tipo de reclamación"
            label="Tipo de reclamación"
          />
          <div className="form-group">
            <label>Pretenciones</label>
            <textarea
              className="form-control large"
              placeholder="Escribe aquí"
              value={formStateRec.data.comentario}
              onChange={changeHandlerRec("comentario")}
            />
          </div>
          <Select
            options={mediosEnvio}
            selectedOption={formStateRec.data.medioRespuestaID}
            handelChange={(value) => {
              changeHandlerRec("medioRespuestaID", value)();
            }}
            placeholder="Selecciona"
            label="¿Dónde deseas recibir la respuesta?"
          />
          <div className="form-group">
            <label>Adjuntar documento de soporte</label>
            <FileUploader
              multiple={true}
              maxSizeMB={2}
              onFileSelectSuccess={(files) => {
                if (files && files.length) {
                  let docs: any[] = [];
                  new Promise((resolve) => {
                    files.forEach(async (doc: File) => {
                      docs.push({
                        documentoName: doc.name,
                        documentoBase64: (await fileToBase64(doc)).split(
                          ";base64,"
                        )[1],
                      });
                      resolve(docs);
                    });
                  }).then((res) => {
                    changeHandlerRec("documentos", res)();
                  });
                } else {
                  changeHandlerRec("documentos", null)();
                }
              }}
              onFileSelectError={({ error }) => {
                showNotification({
                  title: "Error",
                  message: error,
                  isError: true,
                  duration: 0,
                });
              }}
            />
          </div>
          <div className="grid grid-cols-2 gap-4 md:gap-6 pt-[128px] md:pt-8">
            <button
              type="button"
              className="btn btn-secondary btn-large w-full"
              onClick={() => closeFormRec()}
            >
              Cancelar
            </button>
            <button
              type="button"
              className="btn btn-primary btn-large w-full"
              disabled={disableButtonRec()}
              onClick={submitFormRec}
            >
              Enviar
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}

export default WithMainLayout(
  BenefitsRequestsClaims,
  "Solicitudes & Reclamaciones"
);
